module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-2"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Two")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.6em"
    }
  }, [_vm._v("U")]), _vm._v("nder normal circumstances, Darci’s guilt alone would have stopped her from crashing any party anywhere, never mind one that hosted the who’s who of Chicago. But a week into her new job at Colborn Aerospace, she’d learned the oldest records were kept at the Colborn mansion. Tonight was her best chance to look around inside.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d rented a four-thousand-dollar, beaded, gold silk evening gown, splurged on a pair of sparkling heels and shelled out a fortune for hair and makeup at the swankiest salon in her neighborhood. If she did say so herself, she looked fabulous. At a passing glance, nobody would guess that she didn’t belong among the rich and influential.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Now she just needed to get through the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the top of the semicircular staircase, a butler was discreetly checking invitations. Darci hovered at the edge of the driveway, wondering how best to approach him, but she didn’t dare stand still too long or she’d call attention to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A gray-haired couple brushed past her. The woman was dressed in a dramatic peacock-blue gown with a diamond brooch at the shoulder. Making a split-second decision, Darci fell into step beside the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s a lovely brooch,” she said to her as they walked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Luckily, the woman turned and gave her a friendly smile. “Thank you. It’s Cartier.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darci frowned. “Oh dear. You have a little crease.” She boldly reached to the fabric above the brooch, pretending to smooth it out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“May I confirm your invitation, sir,” the butler said to the older man.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darci’s heart thudded as the man handed him a card.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nice of you to join us, Mr. Saunders,” said the butler.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There we go,” Darci said to the woman, keeping her gaze studiously fixed on the dress, pretending she was part of the Saunders party. “That looks much better.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you.” The woman, obviously Mrs. Saunders, nodded her appreciation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Another couple stepped up behind them, drawing the butler’s attention, and Darci quickly moved forward.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her heart was still thudding wildly as they went through the stately front doors and into the huge foyer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Enjoy your evening,” she managed to say to Mrs. Saunders.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Enjoy yours,” Mrs. Saunders replied.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darci peeled off to the right, anxious to mix in with the nearest crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Champagne, ma’am?” asked a neatly uniformed waiter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you.” Darci helped herself to a crystal flute from his tray.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She had no intention of consuming any alcohol, but holding the glass would make her look more like a genuine guest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Earlier in the week, she’d started a job in the records department of Colborn Aerospace. It was an entry-level position, requiring little in the way of experience, with a very low pay rate.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But for her, it was perfect, because it gave her access to the basement of the building. She and Jennifer had then poured over her father’s few belongings, hoping for a clue to the location of the original turbine-design drawings. Unfortunately, they hadn’t found anything else that seemed to help.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But during her company orientation, Darci learned that some of the historical records were stored in the basement of the mansion. So when she read about the search-and-rescue fundraiser, she threw together this plan.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As the guests milled around her in the main reception room, she took an absentminded sip of the champagne. So far, so good.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good evening.” A thirty-something man in a business suit approached her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good evening,” Darci returned, mustering a friendly smile.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He offered his hand. “I’m Lawrence Tucker, Tucker Transportation.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Darci.” She hesitated for a split second, realizing she shouldn’t use her real name. “Lake.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nice to meet you Darci Lake. You’re a supporter of the search-and-rescue program?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Very much so. And you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His handshake was firm, his attitude forthright. He was a fairly attractive man, tall, with broad shoulders that gave him a powerful stance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tucker Transportation donated twenty containers of freight shipping to anywhere in Europe.” He indicated a long row of tables with silent-auction signage above them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You ship to Europe?” She wanted to keep the conversation focused on him and away from her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We ship worldwide. Europe, Africa, Asia, Pacific.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re a large company?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’ve never heard of Tucker Transportation?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve definitely heard of you,” she quickly lied. “But I’m afraid I don’t know many details.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re the third-largest shipping company in the nation.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Impressive.” She took another sip of her champagne.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There you are, Tuck.” A tall, gorgeous blonde woman twined her arm possessively around Lawrence Tucker’s.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hello, Petra.” He greeted her with a quick peck on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She pouted her deep red lips. “Don’t forget, you promised to come with me on a wine-cellar tour.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I haven’t forgotten.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The woman’s gaze moved to Darci, where it paused, becoming speculative.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This is Darci Lake,” said Tuck.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nice to meet you,” said Petra. She didn’t let go of Tuck. If anything, she pressed closer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was several inches taller than Darci and wearing four-inch heels. Darci guessed she was in her late twenties. Her manicure was perfect, as was her hair. And her gown likely cost more than Darci’s. Plus, she probably owned it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It was nice to meet you,” Darci said to Tuck, not having the slightest desire to get between Petra and her designs on the man. “Perhaps I’ll see you again later on.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As she moved toward the back of the house, Darci left the great room behind and found herself in a wide open hall. It had twenty-foot ceilings, marble pillars and gleaming white archways. Antique-style lampposts dotted the perimeter, while an imposing wrought-iron chandelier hung in the center of the room. The decor focused on an equestrian theme, with a big bronze statue of a stallion on a large rough-hewn wood table. Rich oil paintings of rural stables and the countryside hung on the walls, and several red velvet-and-walnut armchairs bordered the room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After an initial scan of the area, Darci found her attention drawn to a small open doorway. It led to a staircase, tucked in a corner behind a pillar and partially screened by one of the lampposts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wandered toward it, pretending to be fascinated by a grandfather clock against the wall. Feeling like a spy, she glanced around to see if anyone was paying attention to her movements.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The crowds were sparser here than out front in the great room. But there were enough people that she blended.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She eased her way behind the lamp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then she moved to the pillar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With another quick check to make sure no one was watching, she scooted to the shadowed staircase and started down.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The stairwell was dim, and she gripped the rail. After what seemed like a long distance, she came out at a narrow white-walled hallway with a blue-and-silver-tiled floor and fluorescent lights along the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her heart began pounding harder as she chose between left and right. Right would take her to the back of the house while left would take her toward the front. It was a toss-up, but it seemed to her that decades-old business records would more likely be at the rear of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She turned right and started along the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She came to a closed door and tried the knob. It was locked. She jiggled it, thinking it was old and it might give way.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Can I help you with something?” came a deep, accusatory voice.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She quickly twisted around, and her heart sank with a thud.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His face was shadowed, but she instantly recognized him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She swallowed. “Mr. Colborn.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He took a step forward, his piercing blue eyes pinning her in place. “Did you take a wrong turn?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her mind scrambled for a plausible explanation. “I, uh...I heard you were giving a wine-cellar tour.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His eyes narrowed. “You did, did you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Petra mentioned it. Petra and Tuck. I was talking to them earlier, and—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You know Tuck?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darci nodded. She’d known Tuck for all of five minutes. But she wasn’t about to get stuck on that detail.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Shane Colborn seemed to relax a bit. “I haven’t seen him yet tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Petra found him. And, well, she didn’t seem to want to share.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Shane cracked a smile. “She doesn’t. She’s had her sights set on him since we were teenagers.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He moved closer still, offering his hand. “I’m Shane Colborn, the host of the party. Well, me and my cousin Madeline are the hosts.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darci immediately accepted the handshake. “I know who you are. I’m Darci Lake. You have a remarkable home.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Remarkable "), _c('em', [_vm._v("appealing")]), _vm._v(", or remarkable "), _c('em', [_vm._v("ostentatious")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A little of both,” she answered before she thought it through. She realized her words had sounded like a criticism. “I mean, it’s wonderful, of course. It’s just that I can’t imagine—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Living here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It is intimidating,” she answered honestly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His furrowed brow told her she was blowing the entire conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Insulting his home was the last thing she wanted to do. “I didn’t mean it the way it came out.” She gave her head a brief shake. “Can I please start over?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She braced herself. “It’s a phenomenal home. And I’m sure you love it here. But it’s more opulent than I’m used to, so it’s hard to imagine living in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That wasn’t a bad recovery.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Personally, I also find it intimidating. And I grew up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So, you were just messing with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That wasn’t a very nice thing to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I found you skulking around my basement, trying to break into a locked room. I don’t think it’s my behavior that deserves criticism.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She could have kicked herself for bringing the conversation back to what she was doing down here. But to her surprise, he offered his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Would you still like to see the wine cellar?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I would,” she quickly answered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The official tour is scheduled for later on, and I have some terrific wines lined up. But we can get a head start.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She slipped her hand into the crook of his elbow. He was steady and sure. Her thumb brushed his biceps and found it defined and hard as iron.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you prefer Old World wines or New World wines?” he asked as they came toward the front of the mansion.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“New World,” she answered, though it was just a stab in the dark. She knew nothing about wines but the color and the price.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So, not a snob?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not a snob,” she agreed easily.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“People seem all excited about malbecs. But give me a solid cabernet sauvignon any day of the week. What about you? Cab sauv? Or maybe pinot noir?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cabernet sauvignon,” she told him, to be agreeable.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("How could he tell? “I’m not.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then you’re being polite.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That would be a change of pace.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gave a low chuckle. It was a very appealing sound.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She caught herself glancing at his profile.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was an astonishingly handsome man. She’d already known that from his many pictures in the media. But the pictures hadn’t done him justice. Some tabloids called him Chicago’s most eligible bachelor, and she wasn’t about to argue the point.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("What woman wouldn’t fantasize about being held in his strong arms and kissing those full lips? Add to that his wealth and his standing in the business community, and she could understand why the elite ladies of Chicago were taking turns as his date.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They passed another closed door, and she remembered why she was here. She needed to stay focused.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s in there?” she asked of the closed door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gave her a puzzled look. “In where?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She backed off, realizing she could easily arouse his suspicions again. “Besides the wine cellar, what do people keep in a great big basement like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gave a glance around the hallway. “Good question. The only place I ever go is the wine cellar, being a playboy bachelor.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Now who’s lying?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His father might have been dishonorable, but a man didn’t run a billion-dollar company by being nothing but a playboy. She didn’t buy for a minute that he’d never looked through his own basement.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Some antique furniture,” he said. “Boxes of things from my parents, probably some art and some silverware. There are no bodies, if that’s what you’re asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It wasn’t. But now that you mention it...” She made a show of gazing worriedly over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We are all alone down here.” He finished her thought in a theatrical voice.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you trustworthy, Mr. Colborn?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not even a little bit. Here we are.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stopped in front of a wide oak door with a thick, twisted wrought-iron handle and long black hinges, strapping the aged planks together. Stonework bracketed the door on both sides, giving the entry an unfortunate dungeon look.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He extracted a long key and inserted it into a deadbolt lock.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For a horrible second, she wondered if he somehow knew who she was and if she ought to be afraid of him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“An estate this size has a lot of staff,” he said as he turned the key. “Some of them are transient. And my father collected some ridiculously valuable wines.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The door swung open with a groan.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Darci peered inside the dark room. “So, this isn’t the place where you lock up the innocent young women caught trespassing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Shane pointed with his thumb. “That room is farther down the hall.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He flicked a light switch, and a massive room came into view. Stone walls stretched back farther than she could see. A huge rectangular wooden table sat in the center of the room, with at least twenty chairs surrounding it. The ceiling was beamed with heavy timbers, supported by thick pillars. Gleaming cedar racks and shelves stretched along each wall, with more rows protruding behind the table.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The room was cold, the scent of cedar hanging in the still air. Most bottles were on their sides in the racks. But some were out on display, while numerous stemmed glasses of varying shapes and sizes hung inverted above the table.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This is incredible,” she whispered, taking a step into the room and turning around to take it all in.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Incredible "), _c('em', [_vm._v("charming")]), _vm._v(" or incredible "), _c('em', [_vm._v("intimidating")]), _vm._v("?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Awe inspiring.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everyone who visited the cellar must have the same reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She moved inside, gazing in amazement. “It makes me want to learn more about wine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What would you like to learn?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She turned to face him. “What’s good?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He drew back in obvious surprise. “Seriously?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For starters.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was expecting a much more specific question.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay. What "), _c('em', [_vm._v("tastes")]), _vm._v(" good?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“In a New World cabernet sauvignon?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were right,” she said. “I was playing along back there. I don’t know anything about wine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She realized she’d have to continue sleuthing as soon as possible. But, for now, it seemed best to see this particular charade through to the end.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was a twinkle in his blue eyes. “Okay.” He pulled out one of the chairs. “Then have a seat.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She did as he asked, and he leaned down as he pushed in the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll stick with New World,” he said, his voice close to her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She found herself inhaling his fresh scent.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No point in making you a snob if you’re not one already. Pinot noir to start. Then a merlot, cabernet sauvignon and shiraz.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Four bottles of wine?” Was he joking? “I’ll get blasted.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He rose. “We’re not going to polish off the bottles.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Of course they weren’t. She’d sounded ridiculously unsophisticated. She tried to backtrack. “I only meant tastings usually work better with more people.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They do,” he said. “Want me to go find some?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t. And that was worrisome. She shouldn’t want to stay here alone with Shane. But she did.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His hand gently brushed her shoulder, and the tone of his voice turned intimate. “Me, neither.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uh-oh.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Before she could formulate a reply, he was gone, moving along the wine racks, perusing the bottles.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She angled her body and watched him from the chair, noting his concentration and the intelligence in his expression as he scrutinized the labels. She’d read he was six feet two. He was obviously in excellent shape. He carried the designer suit with ease across his square shoulders. She could imagine his stomach was washboard hard. She’d already had a chance to feel his biceps.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She knew she couldn’t afford to notice, because she couldn’t afford any kind of a distraction. But there was no getting around it, Shane Colborn was one sexy package of a man. And it seemed she was as susceptible as the next Chicago woman to his looks and his charm.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("Shane realized he was shamefully neglecting his other guests. It was coming up on ten o’clock, and the silent auction was about to close. He knew he should go upstairs and help his cousin Maddie announce the winners, but he wanted to see how Darci felt about the shiraz, the last of their four tastings.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Every time he hosted this fundraiser, he met new people. But few of them fascinated him the way Darci Lake did. She was down-to-earth, unaffected, and he liked her ability to laugh at herself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She swirled the wine in her oversize glass, checking the color and viscosity as he’d told her. Then she leaned down and inhaled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sharper,” she said with a wrinkle of her pert nose.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was distractingly beautiful, with thick, shoulder-length auburn hair. He guessed she was about five feet six. She was slender, with wonderfully rounded breasts, long legs and delicate hands. Her lips were full, her lashes long and her wide eyes were a startling shade of crystalline green. He could barely keep himself from staring at them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She took a sip.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then she nodded decisively. “Sharper. I prefer the cab sauv. Definitely.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Welcome to the dark side.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Worry flashed through her expression. “Is there something wrong with liking cabernet sauvignon? Am I a bohemian?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You have excellent taste in wine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you just saying that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You like what I like.” He replaced her shiraz with a fresh glass of the cab sauv.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She glanced around the tabletop. “We’ve made a mess.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not so bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were going to bring people down here for the tasting.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The staff will clear things up in time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He checked his watch, knowing he was cutting it pretty tight. For a moment, he considered canceling the tasting, coming up with an excuse to keep everyone else upstairs while he stayed here with Darci.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gave a silent thank-you to Justin for talking him out of bringing a date tonight. If he played his cards right, perhaps his perfect streak of getting lucky at the search-and-rescue fundraiser would continue. There were hours to go before it ended, and the DJ was about to get things rolling on the dance floor.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Making the decision, he lifted his own wineglass and rose to his feet. “Let’s take this with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure.” She followed his lead. “Where are we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The dancing’s about to start. You want to dance?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The question seemed to throw her. “With you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure, with me. Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She seemed to scramble. “Uh, you have so many other guests. And you haven’t hosted the real wine tasting yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He leaned across the table to take her hand. “My cousin Maddie will do the other wine tasting. I’ve had enough for now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He kept hold of her hand as they cleared the table and moved through the wine cellar, to the door and out into the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you going to lock it?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No need. The sommelier will be down in a few minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You have a sommelier?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Doesn’t everyone?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her steps faltered, and he realized the joke made him sound like a pretentious jerk.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry,” he said, stopping them both.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tipped up her chin to look at him. “Nothing to be sorry about.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not a spoiled brat. The mansion is purposely equipped for this kind of entertaining. But it’s not my regular life.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But a remoteness had entered her eyes. “Your family has a lot of money. That’s just the way it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t lord it over people, Darci.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t owe me an explanation.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re angry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked away. “I’m really not.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But something had changed. He could tell.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Will you dance with me?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She compressed her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Please dance with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Voices traveled down the hall. Shane recognized the accent. The sommelier and his staff were on their way.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She blinked, and whatever had altered her expression was gone. “Okay,” she said. “One dance.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He impulsively put an arm around her, his fingertips brushing her shoulder as they resumed walking.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sommelier, Julien Duval, appeared in the hallway. “Mr. Colborn, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There’s some cleanup needed in the cellar,” he told Julien.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Right away, sir. You’ll be joining us?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not this time. Can you find Madeline and ask her to stand in?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you, Julien.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Shane followed Darci up the staircase. Her sparkling gold silk dress dipped to a low vee at the back, giving him a marvelous view. It outlined her trim figure and clung enticingly to her backside. He was sorry when they got to the top of the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He touched his hand to the small of her back, guiding her through the hall to the great room, where the music was already playing. People greeted him constantly, and he gave them each a casual hello but kept steadily moving. The music enveloped the two of them as they passed through the archway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He ditched their wineglasses and led her onto the dance floor. There, he turned her into his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The silk of her dress was supple and warm. Her hand was small in his. And their thighs brushed enticingly with the rhythm of the music.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They’d barely begun, and the song ended.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That doesn’t count,” he rumbled in her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you making up the rules?” There was a smile in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He drew back to gaze at her. “My house, my rules.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Happily, the next song was also a waltz. If he’d known he was going to meet Darci tonight, he’d have vetted the DJ’s entire playlist.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re an autocrat?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rarely.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She settled back into his arms, smoothly following his lead. “At Colborn Aerospace. Are you in charge of everything?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Technically, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you a tyrannical boss?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He couldn’t help but smile at that. “I’d say no. But probably every tyrannical boss in the world would tell you no, so you’ll have to ask my staff.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her glance darted around the dance floor. “Are any of them here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A few of the senior managers. You want me to introduce you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No.” Her answer was quick and decisive.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t want to ask them about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t care that much.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m making up my own mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wanted that, he realized. He really wanted this woman to have a chance to make up her own mind about him. He found himself gathering her closer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She resisted at first, going stiff in his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But he persisted, and she eventually relaxed again. Her body softened against his, her curves molding to his angles. He drew their joined hands in close to their bodies, shifting his other palm higher, to the bare skin of her back. Their movements synced, and he couldn’t seem to keep his mind from wandering to a happy conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wanted Darci Lake, wanted her very badly. He brought his cheek to her hair, inhaling a subtle scent of citrus. Her breasts had come up against his chest. Their thighs were touching, shifting together with every beat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gave in to temptation and kissed her hairline, whispering close to her ear. “I want you to stay tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She drew back in a shot, her striking green eyes blinking. She looked truly horrified, and he could have kicked himself.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-309a0c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_Two.vue
// module id = 84
// module chunks = 0